import { SAFETY_OPTIONS } from './fields'

export const formatSafetyOptionToBE = (safetyOptionName, values) => {
  return safetyOptionName + '_' + values[SAFETY_OPTIONS][safetyOptionName]
}
